var Option = function Option() {
  return null;
};
Option.isSelectOption = true;
Option.displayName = 'AAutoCompleteOption';
export default Option;